// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"08fcb04f","453":"19ea1d91","455":"ffd4078d","977":"bafef057"}[chunkId] + ".chunk.js";
};